import React, { useEffect } from 'react';
import { Modal } from '@spotify-internal/anchor-ds';
import { ButtonPrimary } from '@spotify-internal/encore-web';
import { useT } from 'client/i18n/hooks/useT';
import { events } from './events';

const ConfirmationModal = ({
  onClickClose,
  onClickContinue,
}: {
  onClickClose: () => void;
  onClickContinue: () => void;
}) => {
  const t = useT();
  // analytics
  useEffect(() => {
    events.distributeToSpotifyConfirmationScreenView();
  }, []);

  return (
    <Modal
      isShowing
      isShowingCloseButton
      onClose={() => {
        events.distributeToSpotifyConfirmationExitButtonClicked();
        onClickClose();
      }}
      aria-labelledby="confirmation-distribution-title"
      size="small"
    >
      <Modal.Title id="confirmation-distribution-title">
        {t(
          'PreDistributionModalScreen.BinaryDistributionPrompt.ConfirmationModal.Title',
          "You're almost live!",
          'Podcast distribution confirmation modal title'
        )}
        <span role="img" aria-label="Tada emoji">
          🎉
        </span>
      </Modal.Title>
      <Modal.Body>
        {t(
          'PreDistributionModalScreen.BinaryDistributionPrompt.ConfirmationModal.Message',
          "Your podcast will be available on Spotify shortly. We'll let you know as soon as it's ready!",
          'Podcast distribution confirmation modal message'
        )}
      </Modal.Body>
      <Modal.Footer>
        <ButtonPrimary
          onClick={() => {
            events.distributeToSpotifyConfirmationContinueButtonClicked();
            onClickContinue();
          }}
        >
          {t('Button.Continue', 'Continue', 'Continue button text')}
        </ButtonPrimary>
      </Modal.Footer>
    </Modal>
  );
};

export { ConfirmationModal };
